import { type PortfolioListItem } from './portfolio-list';

/** Figma 2047:18083 · 2047:19486 의 예시 줄 */
const HISTORY = [
  { amount: 12_000_000_000, when: '2022-12-31' },
  { amount: 13_000_000_000, when: '2023-12-31' },
  { amount: 21_000_000_000, when: '2024-06-30' },
];

const BASE = {
  defaultCurrency: 'KRW',
  valuatedAt: '2024-06-30',
  remainValuationExchangeRate: 1,
} as const;

/** 부분회수 케이스 A · 임팩트 1호 펀드 (회사의 첫 줄) */
const recoFund1: PortfolioListItem = {
  ...BASE,
  revenueHistory: [...HISTORY],
  stockPriceHistory: [...HISTORY],
  idx: 101,
  portfolioName: '부분회수 케이스 A',
  fundIdx: 1,
  fundName: '임팩트 1호 펀드',
  status: 'PartialExit',
  investD3History: [
    {
      idx: 1,
      investAt: '2021-03-15',
      investVolume: 500_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  exitD3History: [],
  remainValuation: 1_250_000_000,
  irr: 0.184,
  multiple: 2.5,
  internalManagerName: '이몽룡',
  customOrder: 40,
};

/** 부분회수 케이스 A · 스케일업 4호 펀드 (같은 회사의 다음 펀드 줄, 투자 2건 · 부분회수 1건) */
const recoFund2: PortfolioListItem = {
  ...BASE,
  revenueHistory: [...HISTORY],
  stockPriceHistory: [...HISTORY],
  idx: 101,
  portfolioName: '부분회수 케이스 A',
  fundIdx: 3,
  fundName: '스케일업 4호 펀드',
  status: 'PartialExit',
  investD3History: [
    {
      idx: 2,
      investAt: '2022-08-01',
      investVolume: 1_000_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
    {
      idx: 3,
      investAt: '2023-05-10',
      investVolume: 700_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  exitD3History: [
    {
      id: 'exit-1',
      exitType: 'PARTIAL_EXIT',
      exitAt: '2024-02-20',
      exitVolume: 450_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  remainValuation: 2_040_000_000,
  irr: 0.121,
  multiple: 1.5,
  internalManagerName: '이몽룡',
  customOrder: 40,
};

const superbin: PortfolioListItem = {
  ...BASE,
  revenueHistory: [...HISTORY],
  stockPriceHistory: [...HISTORY],
  idx: 102,
  portfolioName: '투자중 케이스 A',
  fundIdx: 2,
  fundName: '임팩트 2호 펀드',
  status: 'None',
  investD3History: [
    {
      idx: 4,
      investAt: '2020-11-02',
      investVolume: 1_000_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  exitD3History: [],
  remainValuation: 3_100_000_000,
  irr: 0.31,
  multiple: 3.1,
  internalManagerName: '성춘향',
  customOrder: 30,
};

const doctornow: PortfolioListItem = {
  ...BASE,
  revenueHistory: [...HISTORY],
  stockPriceHistory: [...HISTORY],
  idx: 103,
  portfolioName: '완전회수 케이스 A',
  fundIdx: 1,
  fundName: '임팩트 1호 펀드',
  status: 'None',
  investD3History: [
    {
      idx: 5,
      investAt: '2022-04-18',
      investVolume: 800_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  exitD3History: [],
  remainValuation: 800_000_000,
  irr: 0,
  multiple: 1,
  internalManagerName: '전우치',
  customOrder: 20,
};

const testworks: PortfolioListItem = {
  ...BASE,
  revenueHistory: [...HISTORY],
  stockPriceHistory: [...HISTORY],
  idx: 104,
  portfolioName: '감액 케이스 A',
  fundIdx: 1,
  fundName: '임팩트 1호 펀드',
  status: 'CompleteImpairment',
  investD3History: [
    {
      idx: 6,
      investAt: '2019-07-09',
      investVolume: 300_000_000,
      exchangeRate: 1,
      exchangeUnit: 'KRW',
    },
  ],
  exitD3History: [],
  remainValuation: 0,
  irr: null,
  multiple: 0,
  internalManagerName: null,
  customOrder: 10,
};

export const portfolioListFixture = {
  /** 줄 하나씩 */
  recoFund1,
  recoFund2,
  superbin,
  doctornow,
  testworks,
  /** 전체 목록: 부분회수 케이스 A(2줄) · 투자중 케이스 A · 완전회수 케이스 A · 감액 케이스 A */
  all: [recoFund1, recoFund2, superbin, doctornow, testworks],
  /** 내 담당 목록: 부분회수 케이스 A(2줄) · 투자중 케이스 A */
  mine: [recoFund1, recoFund2, superbin],
  /** 펀드 안 목록(첫 투자일 오름차순은 부모가 정렬해 넘긴다 — Figma 순서 그대로) */
  fund: [recoFund1, superbin, doctornow, testworks],
} satisfies Record<string, PortfolioListItem | PortfolioListItem[]>;
